import { useSEO } from "@/hooks/useSEO";
import { Hero } from "@/components/home/Hero";
import { AboutSection } from "@/components/home/AboutSection";
import { WhatIDo } from "@/components/home/WhatIDo";
import { InTheNews } from "@/components/home/InTheNews";
import { Testimonials } from "@/components/home/Testimonials";
import { Closing } from "@/components/home/Closing";
import { Marquee } from "@/components/Marquee";

export default function Home() {
  useSEO(
    "James Pratt | Founder, 1-800-Busy Dog Basement Technologies — Basement Waterproofing Company",
    "James Pratt spent 35 years building a basement waterproofing company, holding 16 patents in basement waterproofing, foundation repair, and remodeling before joining forces with Groundworks in 2025."
  );

  return (
    <main id="top" data-testid="home-page">
      <Hero />
      <AboutSection />
      <WhatIDo />
      <InTheNews />
      <Testimonials />
      <Marquee />
      <Closing />
    </main>
  );
}
